// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"b16fa7ba","2237":"f97a37ad","2506":"6aa8e266","4434":"65d32caf","4951":"06ced723","8701":"ac952f4f","9090":"f97e1e3c"}[chunkId] + ".chunk.css";
};